import { useTheme } from 'styled-components';
import { defaultDarkTheme } from '../default';
import { olympicDarkTheme } from '../olympic/olympic';
const darkThemeMatches = {
    dark: defaultDarkTheme,
    light: defaultDarkTheme,
    olympicDark: olympicDarkTheme,
    olympicLight: olympicDarkTheme,
    b2b: defaultDarkTheme,
};
export const useDarkTheme = () => {
    const surroundingTheme = useTheme();
    const darkTheme = darkThemeMatches[surroundingTheme.name];
    return darkTheme;
};
//# sourceMappingURL=useDarkTheme.js.map